export const enum ActionPanelEntryContextMenuQa {
    Menu = 'action-panel-entry-context-menu',
    Revisions = 'action-panel-entry-context-menu-item-revisions',
    Copy = 'action-panel-entry-context-menu-item-copy',
    Remove = 'action-panel-entry-context-menu-item-remove',
    TableOfContent = 'action-panel-entry-context-menu-item-table-of-content',
}

export const enum ActionPanelDashSaveControlsQa {
    SaveAsDraftDropdownItem = 'action-panel-save-as-draft-dropdown-item',
    SaveAndPublishDropdownItem = 'action-panel-save-and-publish-dropdown-item',
    SaveAsNewDropdownItem = 'action-panel-save-as-new-dropdown-item',
    Save = 'action-panel-button-save',
    SaveAsDraft = 'action-panel-button-save-as-draft',
}
